import React from 'react';
import PropTypes from 'prop-types';
import {
    GLUTEN_CROSS_CONTAMINATION,
    MILK_CROSS_CONTAMINATION
} from '../../modules/constants';
/**
 * Display an additional contamination message.
 *
 * @function
 * @param       {object} item          allergen object from the API
 * @param       {boolean} contamination False if allergen is in ingredients list, true if it's possible kitchen or manufacturing contamination.
 * @constructor
 */
function Contamination({ item, contamination }) {
    const { name, message, present } = item;

    const showKitchenCCMessage =
        present === 'MAYBE_FROM_KITCHEN_CROSS_CONTAMINATION';

    // console.log('show message', showKitchenCCMessage);

    // If we have a message from the API display this, if not display the appropriate generic message.
    return (
        <>
            {message ? (
                <p>{message}</p>
            ) : (
                <>
                    {contamination &&
                        showKitchenCCMessage &&
                        name.includes('GLUTEN') && (
                            <p>{GLUTEN_CROSS_CONTAMINATION}</p>
                        )}
                    {contamination &&
                        showKitchenCCMessage &&
                        name.includes('MILK') && (
                            <p>{MILK_CROSS_CONTAMINATION}</p>
                        )}
                </>
            )}
        </>
    );
}

Contamination.propTypes = {
    item: PropTypes.object.isRequired,
    contamination: PropTypes.bool
};

export { Contamination };
